export default __webpack_public_path__ + "unassigned-icon.png";